import { MultiSelect } from "react-multi-select-component";
import classes from "./addsettings.module.css";

const AddSettings = ({
  allow,
  setAttendanceType,
  identity_type,
  setIdentifyType,
  setAllow, 
  setAttendances,
  attendances,
  attendanceType,
}) => {
  const identityTypes = [
    { label: "Face", value: "face" },
    { label: "Mobile", value: "mobile" },
    { label: "Voice", value: "voice" },
  ];
  const options = [
    { label: "Location", value: "location" },
    { label: "Qr", value: "qr" },
    { label: "Device", value: "device" },
    { label: "Device_location", value: "device_location" },
    { label: "Auto_device", value: "auto_device" },
  ];
  const handelAttendanceChange = (attendance_typesArr) => {
    setAttendanceType(attendance_typesArr);
    let attendance_types = [];
    attendance_typesArr.forEach((item) => {
      attendance_types.push(item.value);
    });

    setAttendances((prevItem) => ({
      ...prevItem,
      attendance_types,
    }));
  };

  const identityTypeChange = (identity_typeArr) => {
    setIdentifyType(identity_typeArr);
   

    let identity_types = [];
    identity_typeArr.forEach((item) => {
      identity_types.push(item.value);
    });

    setAttendances((prevItem) => ({
      ...prevItem,
      identity_types,
    }));
  };
  const handelAllowChange = (e) => {
    const isChecked = e.target.checked;
    const newState = isChecked ? 1 : 0;
    setAllow(newState);
    setAttendances((prevItem) => ({
      ...prevItem,
      allow: isChecked ? true : false,
    }));
  };


  return (
    <div className="container">
      <div className="row">
        <div className="card">
          <div className="card-body">
            <div className={classes.formGrid}>
              <div className={classes.formCol}>
                <label htmlFor="">نوع الهوية</label>

                <MultiSelect
                  options={identityTypes}
                  onChange={identityTypeChange}
                  value={identity_type}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor="">نوع الحضور</label>

                <MultiSelect
                  options={options}
                  onChange={handelAttendanceChange}
                  value={attendanceType}
                />
              </div>
              <div className={classes.formCol}>
                <label
                  htmlFor=""
                  className={
                    allow ? `${classes.active}` : `${classes.disActive}`
                  }>
                  {allow === 1 ? " مسموح" : "غير مسموح"}
                </label>

                <label class="switch">
                  <input
                    type="checkbox"
                    onChange={handelAllowChange}
                    checked={allow}
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSettings;
